import { render, staticRenderFns } from "./FccExclusaoSolicitacao.vue?vue&type=template&id=1ab4724b"
import script from "./FccExclusaoSolicitacao.vue?vue&type=script&lang=js"
export * from "./FccExclusaoSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports